import React from "react";
import styled from "styled-components";

import { TValue } from "../../global.types";
import Text from "../text";
import { IInputProps } from "./input";

export const ReadOnlyTabularData = styled.span<{ isLight?: boolean }>`
    font-size: 14px;
    opacity: 0.5;
    color: ${props => !props.isLight ? props.theme.C_TEXT_primary : props.theme.C_TEXT_dialogue};
    padding-top: 8px;
    margin-left: 4px;
    white-space: nowrap;
`;

interface IReadOnlyProps extends Pick<IInputProps<TValue>, "value" | "unit" | "textAlign" | "width" | "isLight" | "tabularData" | "link"> {}

export const ReadOnlyText: React.FC<IReadOnlyProps> = (props) => {
    let text = props.value;

    if (props.unit && !props.value?.toString().endsWith(props.unit)) {
        text += ` ${props.unit}`;
    }

    return (
        <Text textAlign={props.textAlign} width={props.width} isLight={props.isLight}>
            {props.link ? props.link : text}
            {props.tabularData && (
                    <ReadOnlyTabularData
                            isLight={props.isLight}>{props.tabularData}</ReadOnlyTabularData>
            )}
        </Text>
    );
};
